import React, { Component, Fragment } from 'react';
import { clear_auth, set_auth } from "../../reducers/Auth";
import { connect } from "react-redux";

export class Page404 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true
        }
    }

    render() {
        return(
            <Fragment>
                <div className='d-flex align-items-center justify-content-center' style={{ minHeight: "650px" }}>
                    <h6 className='d-flex align-items-center justify-content-center flex-column' style={{  color: '#057CE4', fontSize: 80, fontWeight: 800, gap: 20 }}>404 <span style={{  fontSize: 14 }} className='text-dark'>Halaman Tidak Ditemukan!</span></h6>
                </div>
            </Fragment>
        )
    }
}

const mapStateToProps = state => ({
    user: state.Auth.user,
    api_token: state.Auth.api_token
});

const mapDispatchToProps = dispatch => ({
    clear_auth: () => dispatch(clear_auth()),
    set_auth: (api_token, data) => dispatch(set_auth(api_token, data))
})

export default connect(mapStateToProps, mapDispatchToProps)(Page404);
